import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-mui'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

import { SubmitButton } from '@cibo/ui'
import { Button, FormHelperText, Input, InputLabel, Skeleton, Stack } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { AUTH_ROUTES } from '../../pages/consts'

type VerifyEmailFormProps = {
  error: any
  formAuthToken?: string
  formAuthCode?: string
  loading: boolean
  onSubmit(values: any): void
}

const VerifyEmailForm = ({
  error,
  formAuthToken,
  formAuthCode,
  loading,
  onSubmit,
}: VerifyEmailFormProps) => {
  const { t } = useTranslation('auth')

  /**
   * There is probably a better way to do this.
   * The validation schema never changes, but we need access to the react-i18next
   * context to localize the error messages; hence this ephemeral validation schema
   */
  const RegistrationSchema = Yup.object().shape({
    contactAddress: Yup.string()
      .email(t('emailErrorInvalid'))
      .required(t('emailErrorRequired')),
  })

  const handleSubmit = (values: any) => {
    onSubmit(values)
  }

  if (!formAuthCode && !formAuthToken) {
    return (
      <Stack spacing={4}>
        <Stack>
          <Skeleton>
            <InputLabel>{t('email')}</InputLabel>
          </Skeleton>
          <Skeleton>
            <Input type="text" />
          </Skeleton>
        </Stack>
        <Stack direction="row" justifyContent={'space-between'}>
          <Button component={NavLink} to={AUTH_ROUTES.LOGIN}>
            {t('backToLogin')}
          </Button>
          <Button data-testid="next_button" disabled={true} variant="contained">
            {t('next')}
          </Button>
        </Stack>
      </Stack>
    )
  }

  return (
    <Formik
      validationSchema={RegistrationSchema}
      initialValues={{ formAuthCode, formAuthToken }}
      onSubmit={handleSubmit}
    >
      <Form>
        <Stack spacing={4}>
          <Stack>
            <InputLabel shrink htmlFor="contactAddress">
              {t('email')}
            </InputLabel>
            <Field
              autoFocus
              id="contactAddress"
              name="contactAddress"
              component={TextField}
              //InputProps: yikes
              InputProps={{ inputProps: { 'data-testid': 'registerEmail' } }}
              disabled={loading}
            />
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </Stack>
          <Stack direction="row" justifyContent={'space-between'}>
            <Button component={NavLink} to={AUTH_ROUTES.LOGIN}>
              {t('backToLogin')}
            </Button>
            <SubmitButton data-testid="next_button" disabled={loading} title={t('next')} />
          </Stack>
        </Stack>
      </Form>
    </Formik>
  )
}

export default VerifyEmailForm
